namespace Nbs.Xlr8PageTemplate.Header {
  export const headerMenuHeight = 55;
  export const largeHeaderMenuHeight = 80;
  export let displayLargeHeader = true;
  export const headerBottomBorderWidth = 2;
  export const largeHeaderBottomBorderWidth = 4;

  const environmentBannerMessageHeight = 39;
  const parallaxThreshold = 100;
  let headerMenu: Navigation.MenuItem[] | undefined;
  let isMenuVisible = true;
  let menuClickHandler: undefined | ((menuItem: Navigation.MenuItem) => boolean);
  let environmentBannerMessage: string | undefined;


  export function getEnvironmentBannerMessageHeight() {
    return environmentBannerMessage ? environmentBannerMessageHeight : 0;
  }

  export function getHeight() {
    return (isMenuVisible ? shouldDisplayLargeHeader() ? largeHeaderMenuHeight + largeHeaderBottomBorderWidth
        : headerMenuHeight + headerBottomBorderWidth: 0)
      + getEnvironmentBannerMessageHeight();
  }

  export function getHeightForMenu() {
    return (shouldDisplayLargeHeader() ? largeHeaderMenuHeight + largeHeaderBottomBorderWidth
        : headerMenuHeight + headerBottomBorderWidth)
      + getEnvironmentBannerMessageHeight();
  }

  export function render() {
    const headerRoot = Utilities.getNbsHeaderElement();
    Utilities.replaceChildren(headerRoot, [getHeaderElement()]);
    HeaderMenuButton.render();
    renderEnvironmentBannerMessage();
    expandCollapseHeader();
  }

  export function hideMenu() {
    isMenuVisible = false;
    const div = Utilities.getFirstElementByClass('xpt-header-menu');
    Utilities.addClass(div, 'xpt-display-none');
  }

  export function showMenu() {
    isMenuVisible = true;
    const div = Utilities.getFirstElementByClass('xpt-header-menu');
    Utilities.removeClass(div, 'xpt-display-none');
  }

  export function setMenu(items?: Navigation.MenuItem[]) {
    headerMenu = items;
    renderMenu();
  }

  export function setMenuClickHandler(clickHandler?: ((menuItem: Navigation.MenuItem) => boolean)) {
    menuClickHandler = clickHandler;
  }

  export function renderMenu() {
    const div = Utilities.getFirstElementByClass('xpt-header-menu-wrapper');
    Utilities.replaceChildren(div, [getHeaderMenuElement()]);
  }

  export function renderLogo() {
    const div = Utilities.getFirstElementByClass('xpt-header-logo-container');
    Utilities.replaceChildren(div, [getLogoElement()]);
  }

  export const onClick = (event: MouseEvent) => {
    return Navigation.handleClickEvent(event, headerMenu, menuClickHandler);
  }

  export function setNonProductionEnvironmentMessage(message?: string) {
    environmentBannerMessage = message;
    renderEnvironmentBannerMessage();
  }

  function renderEnvironmentBannerMessage() {
    const environmentBannerMessageDiv = Utilities.getFirstElementByClass('xpt-header-non-production-banner-message');

    if (environmentBannerMessageDiv) {
      if (environmentBannerMessage) {
        Utilities.addClass(document.body, 'xpt-is-non-production');
        environmentBannerMessageDiv.textContent = environmentBannerMessage;
      } else {
        Utilities.removeClass(document.body, 'xpt-is-non-production');
        environmentBannerMessageDiv.textContent = null;
      }
      Menu.setMenuHeight();
      Flyout.setFlyoutHeight();
    }
  }
  function getHeaderContainerElementClasses(){
      const classes = ['xpt-header-container'];
      if (hasLogo()){
        classes.push('large')
      }
      return classes;
  }

  function getHeaderElement() {
    return Utilities.createElement({
      tag: 'header',
      children: [
        Utilities.createElement({
          classes: ['xpt-header-non-production-banner-container'],
          children: [
            Utilities.createElement({ classes: ['xpt-header-non-production-banner-message'] })
          ]
        }),
        Utilities.createElement({
          classes: getHeaderContainerElementClasses(),
          children: [
            Utilities.createElement({ classes: ['xpt-header-logo-container'], children: [getLogoElement()] }),
            Utilities.createElement({ classes: ['xpt-header-menu-wrapper'], children: [getHeaderMenuElement()] })
          ]
        }),
        Utilities.createElement({ classes: ['xpt-header-margin'] })
      ]
    });
  }

  function getLogoElement() {
    const theme = Theme.getCurrentTheme();
    if (theme) {
      const tenantDisplayName = theme.tenantDisplayName || theme.title;

      if (theme.logoUrl && (theme.logoUrl.startsWith('http') || theme.logoUrl.startsWith('data:'))) {
        return Utilities.createElement({
          classes: ['xpt-header-logo'],
          children: [Utilities.createElement({ tag: 'img', attributes: { alt: tenantDisplayName, src: theme.logoUrl } })]
        });
      }

      if (tenantDisplayName) {
        const shortTitleLength = 6;
        const longTitleLength = 60;

        const additionalTitleClasses: string[] = [];
        if (tenantDisplayName.length <= shortTitleLength) {
          additionalTitleClasses.push('xpt-short-title');
        } else if (tenantDisplayName.length >= longTitleLength) {
          additionalTitleClasses.push('xpt-long-title');
        }

        return Utilities.createElement({
          classes: ['xpt-header-title', ...additionalTitleClasses],
          children: [Utilities.createElement({ children: [Utilities.createElement({ children: [tenantDisplayName] })] })]
        });
      }
    }
    return undefined
  }

  let subMenuIterator = 0;
  function getHeaderMenuElement() {
    if (!headerMenu || headerMenu.length === 0) {
      return undefined;
    }

    const desktopLinks = getHeaderDesktopMenuElements(headerMenu).filter(x => !!x);

    const hasAtLeastOneTopLevelMenuItem = !!desktopLinks.length;

    return Utilities.createElement({
      classes: ['xpt-header-menu', isMenuVisible ? '' : 'xpt-display-none'],
      children: [
        Utilities.createElement({
          classes: ['xpt-header-links-container'],
          children: [Utilities.createElement({
            tag: 'nav',
            attributes: { 'aria-label': 'Header Menu' },
            children: [Utilities.createElement({
              tag: 'div',
              attributes: {
                role: hasAtLeastOneTopLevelMenuItem ? Navigation.getContainerRole(headerMenu) : undefined,
              },
              children: [Utilities.createElement({
                tag: 'div',
                classes: ['xpt-main-nav-header'],
                children: desktopLinks,
              })]
            })]
          })]
        }),
        getHeaderMobileMenuElement(headerMenu)
      ]
    });
  }

  function getHeaderDesktopMenuElements(topMenu: Navigation.MenuItem[]) {
    return topMenu.map(topNav => {
      const link = (topNav as Navigation.Link);
      const menu = (topNav as Navigation.Menu);

      if (menu.menuType === Navigation.MenuType.Mobile) {
        return undefined;
      }

      if (menu.childItems) {
        if (menu.childItems.length > 0) {
          const menuLinks = menu.childItems.map(childNav => {
            const childLink = childNav as Navigation.Link;
            let content = Navigation.getMenuItemElements(childLink, onClick);
            let listItemClass = 'xpt-header-menu-text';
            if (Navigation.isEnabledLinkLeafMenuItem(childLink)) {
              content = [Utilities.createElement({
                tag: 'a',
                attributes: Navigation.getLeafAttributes(childLink, menu.childItems),
                eventHandlers: { click: onClick },
                children: content
              })];
              listItemClass = 'xpt-header-menu-link';
            }
            return Utilities.createElement({
              classes: [listItemClass, ...Navigation.getCommonLeafClasses(childLink)],
              attributes: Navigation.isEnabledLinkLeafMenuItem(childLink) ?
                undefined :
                Navigation.getLeafAttributes(childLink, menu.childItems),
              children: content
            });
          });
          const subMenuId = 'uxlSubmenu' + subMenuIterator++;
          const subMenu = Utilities.createElement({
            classes: ['xpt-header-menu-container', 'xpt-hidden'],
            attributes: {
              id: subMenuId,
              role: Navigation.getContainerRole(menu.childItems),
            },
            children: [
              Utilities.createElement({ classes: ['xpt-arrow-up'] }),
              Utilities.createElement({
                tag: 'div',
                classes: ['xpt-header-menu-scrollable-container', 'xpt-scrollable'],
                children: menuLinks,
              }),
            ]
          });

          return Utilities.createElement({
            tag: 'div',
            classes: ['xpt-header-link', ...Navigation.getCommonLeafClasses(menu)],
            attributes: Navigation.getLeafAttributes(menu, topMenu),
            children: [
              Utilities.createElement({
                tag: 'a',
                attributes: {
                  'aria-controls': subMenuId,
                  'aria-expanded': false,
                  'aria-haspopup': true,
                  'aria-label': menu.label,
                  href: '#',
                  role: 'button',
                  title: menu.displayMode === Navigation.DisplayMode.IconOnly ? menu.label : undefined,
                },
                eventHandlers: {
                  click: event => {
                    showHeaderMenu(event.target as HTMLElement);
                    Utilities.stopEvent(event);
                    return false;
                  }
                },
                children: Navigation.getMenuItemElements(menu, onClick, true),
              }),
              subMenu
            ]
          });
        }
      } else if (Navigation.isEnabledLinkLeafMenuItem(link)) {
        return Utilities.createElement({
          tag: 'div',
          classes: ['xpt-header-link', ...Navigation.getCommonLeafClasses(link)],
          children: [Utilities.createElement({
            tag: 'a',
            attributes: Navigation.getLeafAttributes(link, topMenu, false),
            eventHandlers: { click: onClick },
            children: Navigation.getMenuItemElements(menu, onClick),
          })]
        });

      } else if (link.label || link.icon) {
        return Utilities.createElement({
          tag: 'div',
          attributes: Navigation.getLeafAttributes(link, topMenu, false),
          classes: ['xpt-header-link', ...Navigation.getCommonLeafClasses(link)],
          children: Navigation.getMenuItemElements(menu, onClick),
        });
      }

      return undefined;
    });
  }

  function getHeaderMobileMenuElement(topMenu: Navigation.MenuItem[]) {
    const links: HTMLElement[] = [];

    const mobileTopMenu = topMenu.filter(link => link.menuType !== Navigation.MenuType.Desktop);

    const menuRole = Navigation.getContainerRole(mobileTopMenu);

    mobileTopMenu.forEach((topNav, i) => {
      const link = topNav as Navigation.Link;

      const menu = topNav as Navigation.Menu;

      let addHr = false;

      if (menu.childItems) {
        const subLinksMenuRole = Navigation.getContainerRole(menu.childItems);

        const subLinks = menu.childItems.map(childNav => {
          const childLink = childNav as Navigation.Link;
          let content = Navigation.getMenuItemElements(childLink, onClick);
          let containerClass = 'xpt-header-menu-text';
          if (Navigation.isEnabledLinkLeafMenuItem(childLink)) {
            content = [Utilities.createElement({
              tag: 'a',
              attributes: Navigation.getLeafAttributes(childLink, subLinksMenuRole, true),
              eventHandlers: { click: onClick },
              children: content
            })];
            containerClass = 'xpt-header-menu-link';
          }
          return Utilities.createElement({
            classes: [containerClass, ...Navigation.getCommonLeafClasses(childLink)],
            attributes: Navigation.isEnabledLinkLeafMenuItem(childLink) ?
              undefined :
              Navigation.getLeafAttributes(childLink, subLinksMenuRole, true),
            children: content
          });
        });

        links.push(Utilities.createElement({
          tag: 'div',
          attributes: Navigation.getLeafAttributes(menu, menuRole, true),
          children: [Utilities.createElement({
            tag: 'div',
            attributes: {
              role: subLinksMenuRole,
            },
            children: [
              Utilities.createElement({
                classes: ['xpt-header-menu-text', 'xpt-header-menu-section-heading'],
                attributes: { 'aria-level': 2, role: 'heading' },
                children: [menu.label],
              }),
              ...subLinks,
            ],
          })]
        }));

        addHr = true;

      } else if (Navigation.isEnabledLinkLeafMenuItem(link)) {
        links.push(Utilities.createElement({
          classes: ['xpt-header-menu-link', ...Navigation.getCommonLeafClasses(link)],
          children: [Utilities.createElement({
            tag: 'a',
            attributes: Navigation.getLeafAttributes(link, menuRole, true),
            eventHandlers: { click: onClick },
            children: Navigation.getMenuItemElements(link, onClick),
          })]
        }));
        addHr = true;

      } else if (link.label || link.icon) {
        links.push(Utilities.createElement({
          classes: ['xpt-header-menu-text', ...Navigation.getCommonLeafClasses(link)],
          attributes: Navigation.getLeafAttributes(link, menuRole, true),
          children: Navigation.getMenuItemElements(link, onClick),
        }));
        addHr = true;
      }

      if (addHr && i < mobileTopMenu.length - 1) {
        links.push(Utilities.createElement({ tag: 'hr', classes: ['xpt-header-menu-divider'] }));
      }
    });

    return Utilities.createElement({
      classes: ['xpt-header-mobileLinks-container'],
      children: [Utilities.createElement({
        tag: 'nav',
        attributes: { 'aria-label': 'Header Menu' },
        children: [Utilities.createElement({
          classes: ['xpt-header-link'],
          children: [
            Utilities.createElement({
              tag: 'button',
              attributes: { 'aria-controls': 'uxlMenuMobile', 'aria-expanded': false, 'aria-haspopup': true, type: 'button' },
              eventHandlers: {
                click: event => {
                  showHeaderMenu(event.target as HTMLElement);
                  Utilities.stopEvent(event);
                  return false;
                }
              },
              children: [Utilities.getIconElement('more_vert', 'open header menu')]
            }),
            Utilities.createElement({
              classes: ['xpt-header-menu-container', 'xpt-hidden'],
              attributes: { id: 'uxlMenuMobile', role: menuRole, },
              children: [
                Utilities.createElement({ classes: ['xpt-arrow-up'] }),
                Utilities.createElement({
                  tag: 'div',
                  classes: ['xpt-header-menu-scrollable-container', 'xpt-scrollable'],
                  children: links,
                }),
              ]
            })
          ]
        })]
      })]
    });
  }

  function updateDisplayLargeHeaderOnCurrenPosition(){
    const scrollPosition = window.scrollY;
    displayLargeHeader = scrollPosition < parallaxThreshold;
  }

  export function expandCollapseHeader(){
    const headerContainer = Utilities.getFirstElementByClass('xpt-header-container');
    updateDisplayLargeHeaderOnCurrenPosition();
    if (shouldDisplayLargeHeader()){
      Utilities.addClass(headerContainer,'large');
    }
    else{
      Utilities.removeClass(headerContainer,'large');
    }
    Menu.setMenuTop();
    Menu.setMenuHeight();
    Flyout.setFlyoutTop();
  }

  export function shouldDisplayLargeHeader(){
    return displayLargeHeader && hasLogo();
  }

  function hasLogo(){
    const theme = Theme.getCurrentTheme();
    return !!theme?.logoUrl;
  }

}
